import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import 'regenerator-runtime';
import { App } from './App';
import './styles.css';

import('@lemonade-hq/uniclient-app')
  .then(module => {
    module.initDatadog(window.lemonade?.stage ?? 'development');
  })
  .catch(() => {});

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = ReactDOM.createRoot(document.querySelector('#root')!);
root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);
